// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "fbce6de221f4bdf5ae99" + ".chunk.js";
};